import * as types from '../mutation-types';


// initial state
const state = {
  menu: {},
  theme: '',
};

// getters
const getters = {
  navigation: stateFreezed => stateFreezed.menu,
  navigationTheme: stateFreezed => stateFreezed.theme,
};

// actions
const actions = {
  fetchNavigation({ commit }, params) {
    params.$http.get(`/${params.lang}/api/navigation/`)
    .then((response) => {
      // get body data
      commit(types.RECEIVE_NAVIGATION, response.body.navigation);
    });
  },
};

// mutations
const mutations = {
  [types.RECEIVE_NAVIGATION](stateFreezed, navFetched) {
    const st = stateFreezed;
    st.menu = navFetched;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js